<template>
    <div class="playlist">
        <base-settings-row
            config-title="Featured"
            input-type="checkbox"
            :fields-config="displayFeaturedConfig"
            :binded-value="settings.playlist.displayFeaturedEpisodes"
            settings-key="displayFeaturedEpisodes"
            @change="value => $emit('nested-config-change', { parent: 'playlist', data: { ...value } })"
        />
        <base-settings-row
            class="is-centered"
            config-title="Default order"
            input-type="select"
            :fields-config="defaultOrderConfig"
            :binded-value="settings.playlist.order"
            settings-key="order"
            :is-active="hasArchivePlayers"
            @change="value => $emit('nested-config-change', { parent: 'playlist', data: { ...value } })"
        />
        <base-settings-row
            config-title="Features"
            input-type="checkbox"
            :fields-config="featuresConfig"
            :binded-value="settings.playlist.features"
            settings-key="features"
            :is-active="hasArchivePlayers"
            @change="value => $emit('nested-config-change', { parent: 'playlist', data: { ...value } })"
        />
        <base-settings-row
            v-if="!settings.sticky"
            :binded-value="settings.playlist.defaultHidden"
            :fields-config="playlistToggle"
            config-title="Playlist Toggle"
            input-type="checkbox"
            settings-key="defaultHidden"
            @change="value => $emit('nested-config-change', { parent: 'playlist', data: { ...value } })"
        />
    </div>
</template>

<script>
import { Feature, hasFeature } from '@/utils/show';

export default {
    props: {
        settings: {
            type: Object,
            required: true,
        },

        show: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        defaultOrderConfig: [
            {
                label: 'Newest first',
                value: 'desc',
            },
            {
                label: 'Oldest first',
                value: 'asc',
            },
        ],
        featuresConfig: [
            {
                label: 'Search box',
                value: 'searchbox',
            },
            {
                label: 'Sort',
                value: 'sort',
            },
            {
                label: 'Open in new window',
                value: 'popup',
            },
        ],
        displayFeaturedConfig: [
            {
                label: 'Show featured episodes',

            },
        ],
        playlistToggle: [
            {
                label: 'Hide playlist by default',
                value: 'hidePlaylist',
            },
        ],
    }),

    computed: {
        /**
         * Checks if the show has archive players feature enabled.
         *
         * @returns {boolean} True if the show has archive players feature.
         */
        hasArchivePlayers() {
            return hasFeature(this.show, Feature.ArchivePlayer);
        },
    },
};
</script>
